import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectAffectionDepartment } from "../Model/ProposalProjectAffectionDepartment";

export async function getProposalProjectAffectionDepartment(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-affectation-department/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectAffectionDepartment = response.map(data => ProposalProjectAffectionDepartment.createFromResponseData(data));
	return proposalProjectAffectionDepartment;
}
